<template>
  <div>
    <app-navigation
      v-bind:activeFacade="activeFacade"
      v-bind:nextTrigger="next"
    ></app-navigation>
    <div class="header-bar" v-if="activeHome">
      <div class="back-box">
        <a class="button app-accent" @click="goBack">BACK TO LIST</a>
        <a class="button app-primary pulse" @click="goNext()"
          >CONFIRM SELECTION</a
        >
      </div>
    </div>
    <div class="facade-list-page" v-if="activeHome">
      <div class="container">
        <div class="facade-list">
          <div
            v-for="facade of activeHome.facadelist"
            @click="selectFacade(facade)"
          >
            <img
              :src="facade.imageurl"
              :class="{
                'is-active': facade.cpidstring === activeFacade.cpidstring
              }"
            />
          </div>
        </div>
        <div>
          <div class="info">
            <div class="left-item">
              <p>{{ activeHome.designproductname }}</p>
              <div class="amenities">
                <div class="amenity">
                  <img :src="require('@/assets/icons/bed.svg')" alt="" />
                  <span>{{ activeHome.noofbedrooms }}</span>
                </div>
                <div class="amenity">
                  <img :src="require('@/assets/icons/bath.svg')" alt="" />
                  <span>{{ activeHome.noofbathrooms }}</span>
                </div>
                <div class="amenity">
                  <img :src="require('@/assets/icons/car.svg')" alt="" />
                  <span>{{ activeHome.noofcarparks }}</span>
                </div>
              </div>
            </div>
            <div class="right-item">
              <p>${{ activeHome.productprice.toLocaleString() }}</p>
            </div>
          </div>
          <div class="active-facade">
            <img :src="activeFacade.imageurl" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navigation from "@/components/journey/nav/Navigation";

export default {
  name: "app-community-facade",
  mixins: [],
  components: {
    "app-navigation": Navigation
  },
  data() {
    return {
      activeHome: null,
      activeFacade: null,
      sub: null,
      next: false
    };
  },
  watch: {},
  created() {
    this.getActiveHome();
  },
  beforeDestroy() {
    this.sub();
  },
  methods: {
    getActiveHome: function() {
      this.$store.dispatch("getActiveHome", this.$route.query.homeid);
      this.sub = this.$store.subscribe((mutation, state) => {
        if (mutation.type === "setActiveHome") {
          this.activeHome = state.communityStore.activeProduct.home;
          if (this.activeHome && this.activeHome.facadelist.length) {
            this.activeFacade = this.activeHome.facadelist[0];
          }
        }
      });
    },

    goBack: function() {
      return this.$router.push({
        path: "/community/homes",
        query: {
          lotid: this.$route.query.lotid,
          lotcpid: this.$route.query.lotcpid
        }
      });
    },

    goNext() {
      this.$store.dispatch("productEvent", this.activeFacade);
      if (this.$route.query.lotid && this.$route.query.lotcpid) {
        return (this.next = true);
      } else {
        return this.$router.push({
          path: "/community/lot",
          query: {
            homeid: this.$route.query.homeid,
            facadeid: this.activeFacade.cpidstring,
            plancpid: this.$route.query.plancpid
          }
        });
      }
    },

    selectFacade: function(facade) {
      this.activeFacade = facade;
      this.$store.dispatch("productTracking", { product: facade, page: "" });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/journey/home/Facade.vue